// extracted by mini-css-extract-plugin
module.exports = {"avatarImageWrap":"AvatarIcon_avatarImageWrap__ipnaL","userImage":"AvatarIcon_userImage__K4Obp","userBackGround":"AvatarIcon_userBackGround__4e72e"};